// eslint-disable-next-line import/prefer-default-export
export const getCurrentPage = (page, items) => {
  if (page === 1) {
    return 1;
  }

  if (page > 1 && items.length > 1) {
    return page;
  }

  return page - 1;
};

export const calculateCurrentPage = (size, order, page) =>
  order > size && page > 1 ? Math.ceil(order / size) : 1;
